import auth from "./authReducer";
import scenario from "./scenarioReducer";
import answer from "./answerReducer";

export { scenario, auth, answer };
